import {SelectOptionsType} from 'global';
import {useGetAllWorkSpaces} from 'hooks';
import React, {useEffect, useMemo} from 'react';
import {AppControlledAutoCompleteProps, AppControlledAutoComplete} from './AutoComplete';

interface AppWorkspaceSelectProps extends Omit<AppControlledAutoCompleteProps, 'options' | 'value'> {}

export const AppWorkspaceSelect = (props: AppWorkspaceSelectProps) => {
    const {getAllWorkSpaces, getAllWorkSpacesLoading, getAllWorkSpacesResponse} = useGetAllWorkSpaces();

    useEffect(() => {
        getAllWorkSpaces();
    }, []);

    const statusOptions: SelectOptionsType[] = useMemo(() => {
        if (!getAllWorkSpacesLoading && getAllWorkSpacesResponse) {
            return getAllWorkSpacesResponse.map(x => ({
                label: x.title,
                value: x.slug,
            }));
        }
        return [];
    }, [getAllWorkSpacesResponse, getAllWorkSpacesLoading]);

    return <AppControlledAutoComplete loading={getAllWorkSpacesLoading} options={statusOptions} {...props} />;
};

export default AppWorkspaceSelect;
